import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { Spinner } from '@/components/ui/spinner';
import { useRouter } from '@/hooks/use-router';
import { useDynamicDetail, useDynamicList } from '@/services/dynamic-resource';
import { SaleQuickView } from './sale-quick-view';

interface ViewSaleModalProps {
  saleId: string | null;
  onOpenChange: (open: boolean) => void;
}

/** Visualização rápida do pedido sem sair do Kanban. */
export function ViewSaleModal({ saleId, onOpenChange }: ViewSaleModalProps) {
  const { push } = useRouter();
  const { data: sale } = useDynamicDetail('sales', saleId ?? '');
  const { data: itemsResponse } = useDynamicList('sale-items', {
    saleId: saleId ?? '',
    perPage: 100,
  });

  const items = (itemsResponse?.data ?? []).filter((item: any) => item.saleId === saleId);

  return (
    <Dialog open={!!saleId} onOpenChange={(open) => !open && onOpenChange(false)}>
      <DialogContent
        showCloseButton={false}
        className="top-14 max-h-[calc(100vh-112px)] max-w-[920px] translate-y-0 gap-0 overflow-y-auto rounded-[18px] border-border-strong bg-card p-0 shadow-[var(--shadow-float)]"
      >
        {sale ? (
          <SaleQuickView
            sale={sale}
            items={items}
            onEdit={() => push(`/sales/${saleId}`)}
          />
        ) : (
          <div className="flex items-center justify-center p-16">
            <DialogTitle className="sr-only">Carregando pedido</DialogTitle>
            <Spinner />
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
